<template>
  <div class='generic-list'>
     <h3>National MHP Cost Rate</h3>
     <el-table :data="data" style="margin-top: 1em; width: 100%">
         <el-table-column
            v-for="(column, index) in tableColumns"
            :key="index"
            :label="column.label"
            :width="column.width"
            :prop="column.prop"
            :formatter="column.formatter"
         />
         <el-table-column
            fixed="right"
            label="Operations"
            width="120">
            <template slot-scope="scope">
               <el-button @click="editCost(scope.row);" type="text" size="small">Edit</el-button>
            </template>
         </el-table-column>
      </el-table>
      <el-pagination
         @size-change="handleSizeChange"
         @current-change="handleCurrentChange"
         :current-page.sync="currentPage"
         :page-sizes="[10, 15, 20, 50, 100]"
         :page-size="pageSize"
         layout="sizes, prev, pager, next"
         :total="total">
      </el-pagination>
      <common-dialog-form
         :visible="showForm"
         title="Edit Cost"
         @close="showForm=false"
         @submit="handleFormSubmit"
         >
         <input-field
            label="Category"
            type="text"
            v-model="form.category"
            :errors="[]"
            required
         />
         <input-field
            label="System cost per kW"
            type="number"
            v-model="form.sc_per_kW"
            :errors="[]"
            required
         />
         <input-field
            label="Installation cost per kW"
            type="number"
            v-model="form.ic_per_kW"
            :errors="[]"
            required
         />
         <input-field
            label="Transportation cost per kW"
            type="number"
            v-model="form.tc_per_kW"
            :errors="[]"
            required
         />
         <input-field
            label="Operation & Maintenance cost per kW"
            type="number"
            v-model="form.omc_per_kW"
            :errors="[]"
            required
         />
      </common-dialog-form>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Pagination } from 'element-ui';
import CommonDialogForm from '@/components/organisms/Home/CommonDialogForm';
import InputField from '@/components/molecules/Login/InputField';
import { fetchWithAuthToken } from '@/axios';
import { showError, showSuccess } from '../../../../../js/ui-helpers';
import { postWithAuthToken } from '../../../../../axios';

export default {
   name: 'generic-list',
   components: {
      'el-table': Table,
      'el-table-column': TableColumn,
      'el-button': Button,
      'el-pagination': Pagination,
      CommonDialogForm,
      InputField,
   },
   data() {
      const tableColumns = [
         { label: "Id", prop: "id" },
         { label: "Category", prop: "category" },
         { label: "System cost per kW", prop: "sc_per_kW" },
         { label: "Installation cost per kW", prop: "ic_per_kW" },
         { label: "Transportation cost per kW", prop: "tc_per_kW" },
         { label: "Operation and Maintenance cost per kW", prop: "omc_per_kW" },
      ];
      return {
         tableColumns,
         data: [],
         currentPage: 1,
         pageSize: 15,
         total: 0,
         form: {
            id: 0,
            category: '',
            sc_per_kW: 0,
            ic_per_kW: 0,
            tc_per_kW: 0,
            omc_per_kW: 0,
         },
         showForm: false,
      }
   },
   created()
   {
      this.loadData();
   },
   methods: { 
      editCost(cost)
      {
         this.showForm = true;
         this.form = {...cost};
      },
      loadData()
      {
         fetchWithAuthToken(`/api/bat/mhp/list?page=${this.currentPage}&page_size=${this.pageSize}`)
         .then(({data}) => {
            this.data = data.results;
            this.total = data.count;
            console.log(data)
         })
      },
      handleSizeChange(val)
      {
         this.pageSize = val;
         this.loadData();
      },
      handleCurrentChange(val)
      {
         this.currentPage=val;
         this.loadData();
      },
      async handleFormSubmit()
      {
         try
         {
            this.showForm = false;
            const url = `/api/bat/mhp/updaterate/${this.form.id}`;
            await postWithAuthToken(url, this.form, {method: 'PUT'});
            this.loadData();
            showSuccess("Cost Edit", `Successfully updated the cost rate`);
         }
         catch (error)
         {
            console.log(error);
            showError("Cost Edit",  `Failed to update the cost.`);
         }
      },
   }
}
</script>

<style lang="scss" scoped>
.generic-list {
   padding: 1em;
}
</style>
/style>
